import { Board } from "../../../reducers/uploadedBoard";
import useBoardInventory from "../../../utils/hooks/inventory/boardInventory";
import { StatusTableCell, Title } from "./BoardInventoryStyles";
import React, { useContext } from "react";
import {
  FlashPCBTable,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from "../../../constants/Styles";
import LoadingIcon from "../../common/LoadingIcon";
import ApproveAllocationButton from "./ApproveAllocationButton";
import {
  BoardIdContext,
  BoardShipmentIds,
} from "../../../utils/hooks/commonly-stored/uploaded-board/state-machine/reviewBoardFlowLoader";

export default function PartStatusDetails({ board }: { board: Board }) {
  const { shipmentId } = useContext(BoardIdContext) as BoardShipmentIds;
  const { boardPartsResponse } = useBoardInventory(board.id, shipmentId);

  if (boardPartsResponse === null) {
    return <LoadingIcon text={"Loading..."} />;
  }

  const partsWithQuantityBelowRequiredAmount = boardPartsResponse?.parts.filter(
    (part) => {
      return part.amount_allocated < part.required_amount;
    },
  );

  return (
    <>
      <Title>{`${board.project_name} outstanding parts`}</Title>
      <FlashPCBTable>
        <thead>
          <TableHeaderRow>
            <TableHeaderCell>Part</TableHeaderCell>
            <TableHeaderCell>Manufacturer</TableHeaderCell>
            <TableHeaderCell>Minimum parts needed</TableHeaderCell>
            <TableHeaderCell>
              Quantity required with attrition / spillage
            </TableHeaderCell>
            <TableHeaderCell>Total last counted amount</TableHeaderCell>
            <TableHeaderCell>Allocated to this project</TableHeaderCell>
            <TableHeaderCell>
              Active allocations to other projects
            </TableHeaderCell>
            <TableHeaderCell>
              Spent allocations to other projects
            </TableHeaderCell>
            <TableHeaderCell>Approve current allocation</TableHeaderCell>
          </TableHeaderRow>
        </thead>
        <tbody>
          {partsWithQuantityBelowRequiredAmount.map((part) => (
            <TableRow key={part.part.id}>
              <StatusTableCell>{part.part.name}</StatusTableCell>
              <StatusTableCell>{part.part.manufacturer}</StatusTableCell>
              <StatusTableCell>
                {part.num_elements_per_shipment}
              </StatusTableCell>
              <StatusTableCell>{part.required_amount}</StatusTableCell>
              <StatusTableCell>
                {
                  part.inventory_response.physical_inventory
                    .last_counted_amount_total
                }
              </StatusTableCell>
              <StatusTableCell>{part.amount_allocated}</StatusTableCell>
              <StatusTableCell>
                {part.inventory_response.physical_inventory
                  .active_allocations_total - part.amount_allocated}
              </StatusTableCell>
              <StatusTableCell>
                {
                  part.inventory_response.physical_inventory
                    .spent_allocations_total
                }
              </StatusTableCell>
              <StatusTableCell>
                <ApproveAllocationButton part={part} />
              </StatusTableCell>
            </TableRow>
          ))}
        </tbody>
      </FlashPCBTable>
    </>
  );
}
